import { fromZonedTime } from 'date-fns-tz';
import React from 'react';

import { useMarketReactionData } from '~/hooks/use-market-reaction-data/useMarketReactionData';
import { MarketReactionChart } from '~/modules/market-reaction-charts/MarketReactionChart';
import { useEntities } from '~/react-query-hooks/entities/useEntities';
import { usePriceChangeHistoryList } from '~/react-query-hooks/prices/usePriceChangeHistoryList';

export interface MarketCatalystReactionProps {
  tickers: string[];
  tags: string[];
  createdAt: string;
}

export const MarketCatalystReaction = ({
  tickers,
  tags,
  createdAt,
}: MarketCatalystReactionProps) => {
  const isMultipleETFs = tickers.length > 1;
  const { priceChangeData, fromDateEST, toDateEST } = useMarketReactionData({
    ticker: tickers[0],
    reportingDate: createdAt,
  });

  const { data: entitiesData } = useEntities({
    entityTags: tags,
    enabled: isMultipleETFs,
  });

  const fromDateUTC = fromDateEST
    ? fromZonedTime(fromDateEST, 'America/New_York')
    : undefined;
  const toDateUTC = toDateEST
    ? fromZonedTime(toDateEST, 'America/New_York')
    : undefined;
  const { data: rawPriceChangeDataList, isLoading } = usePriceChangeHistoryList(
    {
      tickers: tickers.slice(1),
      reference: fromDateUTC?.toISOString() ?? '',
      from: fromDateUTC?.toISOString() ?? '',
      to: toDateUTC?.toISOString() ?? '',
      enabled: tickers.length > 1 && !!fromDateUTC && !!toDateUTC,
    }
  );

  // const fromDateEST = toDateEST ? addMonths(toDateEST, -3) : undefined;
  // TODO - Waiting for BE / Product reponse to few questions
  // const { data: performanceData } = useFetchSnakeByName(
  //   'xlv_arca.price',
  //   // 253,
  //   undefined,
  //   fromDateEST?.toISOString() ?? '',
  //   // undefined,
  //   tickers.length > 1 && !fromDateEST
  // );

  if (!priceChangeData || isLoading) {
    return null;
  }

  // if (performanceData?.tsData?.length) {
  //   const bis = bisector((d: TSDatum) => d.index);

  //   const createdAtIndex = performanceData.tsData.findIndex(data =>
  //     isSameDay(data.index, createdAt)
  //   );
  //   const bisectIndex = bis.left(performanceData.tsData, createdAt);

  //   const baseIndex = createdAtIndex !== -1 ? createdAtIndex : bisectIndex;

  //   const test =
  //     ((performanceData.tsData[baseIndex].value -
  //       performanceData.tsData[0].value) /
  //       performanceData.tsData[0].value) *
  //     100;
  //   console.log(
  //     performanceData.tsData[baseIndex].value,
  //     performanceData.tsData[0].value,
  //     { test }
  //   );
  // }

  // TODO
  // const horizonTranslationMap = {
  //   intraday: t('insights:catalyst.horizons.intraday'),
  //   '1d': t('insights:catalyst.horizons.1d'),
  //   '1w': t('insights:catalyst.horizons.1w'),
  //   '1m': t('insights:catalyst.horizons.1m'),
  //   '3m': t('insights:catalyst.horizons.3m'),
  // };

  // const horizonPerformances = data[0].map((item) => {

  // });
  // const performanceData = Object.entries(data.performance).reduce(
  //   (acc, [key, val]) => {
  //     const horizon =
  //       horizonTranslationMap[key as keyof typeof horizonTranslationMap];

  //     if (horizon) {
  //       acc[horizon] = val;
  //     }

  //     return acc;
  //   },
  //   {} as Record<string, number>
  // );

  const lines = [priceChangeData, ...rawPriceChangeDataList];
  return (
    <>
      <MarketReactionChart
        fromDateEST={fromDateEST}
        toDateEST={toDateEST}
        lines={lines}
        entities={isMultipleETFs ? entitiesData : undefined}
      />
      {/* TODO only display horizon selector when there is a single ticker */}
      {/* <S.HorizonSelector>
        <S.HorizonItem>
          <S.HorizonItemTitle>
            {horizonTranslationMap.intraday}
          </S.HorizonItemTitle>
          <S.HorizonItemValue
            $isNegative={!!MOCK_INTRADAY_VALUE && MOCK_INTRADAY_VALUE < 0}
          >
            {formatNumber({ isPercentage: true, value: MOCK_INTRADAY_VALUE })}
          </S.HorizonItemValue>
        </S.HorizonItem>
        {horizonPerformances.map((perf) => (
          <S.HorizonItem key={key}>
            <S.HorizonItemTitle>{key}</S.HorizonItemTitle>
            <S.HorizonItemValue $isNegative={!!value && value < 0}>
              {formatNumber({ isPercentage: true, value: value })}
            </S.HorizonItemValue>
          </S.HorizonItem>
        ))}
      </S.HorizonSelector> */}
    </>
  );
};
